/*============
Date Constants
============*/

//Days of the week
export const WEEK_DAYS   = ['MON', 'Tues', 'Wed', 'Thurs', 'Fri', 'Sat', 'Sun']

//Months of the year
export const YEAR_MONTHS = ['Jan', 'Feb', 'Mar', 'April', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']